import { Controller } from "@hotwired/stimulus"
import _ from "datatables.net-fixedcolumns-dt"
import DataTable from 'datatables.net-zf'
import {fetch, translate as t} from 'common/i18n'
import $ from 'jquery'

export default class extends Controller {
  static targets = ['table']
  static values = {
    options: Object,
  }

  connect() {
    this.table = this.element.querySelector(':scope > table')
    if(this.hasTableTarget) this.table = this.tableTarget
    const options = {
      ...this.optionsValue,
      fixedColumns: true
    }
    const filter = options['x-filter']
    delete options['x-filter']

    options.language = fetch('datatables', {raise: false}) || {}

    if(filter) {
      DataTable.ext.search.push((settings, values, idx, data)=> {
        if(settings.nTable != this.table) return true;
        this.datacache = this.datacache || {}
        let found = true
        Object.keys(this.filter || {}).forEach((col)=> {
          const filter = this.filter[col] || []
          this.datacache[col] = this.datacache[col] || []
          let d = this.datacache[col][idx]
          if(!d) {
            d = JSON.parse(data[col]['@data-search'] || '[]')
            this.datacache[col][idx] = d
          }
          if(filter.length > 0 && !filter.find((x)=> d.indexOf(x) > -1))
            found = false
        })
        return found
      })
    }

    this.dt = new DataTable(this.table, options)

    if(filter) this.parseFilter(filter)
  }

  redraw() {
    this.dt.draw()
  }

  reload() {
    this.dt.rows().invalidate()
  }

  parseFilter(filter) {
    let options = ''
    filter.forEach((f) => {
      const col = f.shift()
      const o = f.map((o)=> `<li><a class="datatable-filter" href="" data-filter-column="${col}" data-filter-value="${o[1]}"><i class="far fa-lg fa-square"></i><i class="far fa-lg fa-square-check"></i> ${o[0]}</a></li>`)
      options = options + o.join('')
    })

    const id = `dd-${Math.round(Math.random()*1000000)}`
    options = `
      <button class="dropdown button secondary hollow margin-0" type="button" data-toggle="${id}">${t('filters')}</button>
      <div class="dropdown-pane" id="${id}" data-dropdown data-auto-focus="true" data-close-on-click="true">
        <ul class="menu vertical">${options}</ul>
      </div>
    `
    const dd = document.createElement('div')
    const search = this.element.querySelector('.dt-foundation > .grid-x:first-of-type > .cell:last-of-type')
    search.classList.remove('shrink')
    search.classList.add('large-5')
    search.classList.add('medium-6')
    search.classList.add('small-12')
    search.classList.add('margin-bottom-1')
    const container = this.element.querySelector('.dt-foundation > .grid-x:first-of-type > .cell:first-of-type')

    if(container) {
      container.insertBefore(dd, container.firstChild)
      container.classList.add('margin-bottom-1')
      dd.innerHTML = options
      $(document).foundation()

      dd.addEventListener('click', (ev)=> {
        let target = ev.target
        if(target.nodeNane == 'I' && target.parentNode.nodeName == 'A') target = target.parentNode
        if(target.dataset.filterColumn && target.dataset.filterValue) {
          ev.preventDefault()
          target.classList.toggle('active')
          const filter = {}
          dd.querySelectorAll('a[data-filter-column]').forEach((a)=> {
            const c = a.dataset.filterColumn
            const v = a.dataset.filterValue
            filter[c] = filter[c] || []
            if(a.classList.contains('active')) filter[c].push(v)
          })
          this.applyFilter(filter)
        }
      })
      
      const grid = container.closest('.grid-x')
      const sticky = grid.closest('.sticky-table')
      if(sticky) {
        let header = sticky.querySelector('.sticky-table-header')
        if(!header) {
          header = document.createElement('div')
          header.classList.add('sticky-table-header')
          sticky.prepend(header)
        }
        header.appendChild(grid)

        sticky.style.setProperty('--sticky-top', `${header.clientHeight}px`)
      }
    }
  }

  applyFilter(filter) {
    this.filter = filter
    this.dt.draw()
  }
}
